import React from "react";
import {
  FacebookOutlined,
  TwitterOutlined,
  InstagramOutlined,
  LinkedinOutlined,
  MailOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import { contactDetails } from "../../../utils/appconst";

const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-slate-950 text-white">

      {/* Background */}

      <div className="absolute -left-40 top-0 h-96 w-96 rounded-full bg-red-600/10 blur-[140px]" />

      <div className="absolute right-0 bottom-0 h-[420px] w-[420px] rounded-full bg-orange-500/10 blur-[160px]" />

      <div className="relative">

        {/* CTA */}

        <div className="border-b border-white/10">

          <div className="max-w-7xl mx-auto px-6 py-20">

            <div className="rounded-[36px] bg-gradient-to-r from-red-600 via-red-500 to-orange-500 p-10 lg:p-14">

              <div className="flex flex-col lg:flex-row items-center justify-between gap-8">

                <div>

                  <h2 className="text-4xl lg:text-5xl font-black">

                    Ready To Grow Your Business?

                  </h2>

                  <p className="mt-4 text-lg text-red-100 max-w-2xl">

                    Join thousands of businesses using SupaRecords to manage
                    inventory, accounting, sales and purchasing from anywhere.

                  </p>

                </div>

                <a
                  href="https://admin.suparecords.ng/auth/signup"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-3 rounded-2xl bg-white px-8 py-5 font-semibold text-red-600 transition hover:scale-105"
                >
                  Start Free

                  <ArrowRightOutlined />

                </a>

              </div>

            </div>

          </div>

        </div>

        {/* Footer */}

        <div className="max-w-7xl mx-auto px-6 py-20">

          <div className="grid gap-16 md:grid-cols-2 lg:grid-cols-4">

            {/* Company */}

            <div>

              <div className="flex items-center gap-3">

                <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-red-600 to-orange-500 font-black text-xl">

                  S

                </div>

                <div>

                  <h3 className="text-2xl font-black">

                    SupaRecords

                  </h3>

                  <p className="text-sm text-slate-400">

                    Inventory & Accounting

                  </p>

                </div>

              </div>

              <p className="mt-8 leading-8 text-slate-400">

                Modern inventory management, accounting,
                sales, purchasing and warehouse software
                built for growing businesses.

              </p>

            </div>

            {/* Product */}

            <div>

              <h3 className="text-xl font-bold">

                Product

              </h3>

              <ul className="mt-8 space-y-4 text-slate-400">

                <li>
                  <a href="#features" className="hover:text-white">
                    Features
                  </a>
                </li>

                <li>
                  <a href="#pricing" className="hover:text-white">
                    Pricing
                  </a>
                </li>

                <li>
                  <a href="#faq" className="hover:text-white">
                    FAQ
                  </a>
                </li>

                <li>
                  <a href="#testimonials" className="hover:text-white">
                    Testimonials
                  </a>
                </li>

              </ul>

            </div>

            {/* Contact */}

            <div>

              <h3 className="text-xl font-bold">

                Contact

              </h3>

              <div className="mt-8 space-y-6">

                <div className="flex gap-4">

                  <PhoneOutlined className="mt-1 text-red-400" />

                  <span className="text-slate-400">

                    {contactDetails?.phoneNumberContact}

                  </span>

                </div>

                <div className="flex gap-4">

                  <MailOutlined className="mt-1 text-red-400" />

                  <span className="text-slate-400">

                    {contactDetails?.emailAddress}

                  </span>

                </div>

                <div className="flex gap-4">

                  <EnvironmentOutlined className="mt-1 text-red-400" />

                  <span className="text-slate-400">

                    {contactDetails?.address}

                  </span>

                </div>

              </div>

            </div>

            {/* Social */}

            <div>

              <h3 className="text-xl font-bold">

                Follow Us

              </h3>

              <p className="mt-6 text-slate-400 leading-8">

                Stay connected for product updates,
                feature releases and business tips.

              </p>

              <div className="mt-8 flex gap-4">

                {[
                  {
                    icon: <FacebookOutlined />,
                    link: contactDetails?.facebookLink,
                  },
                  {
                    icon: <TwitterOutlined />,
                    link: contactDetails?.twitterLink,
                  },
                  {
                    icon: <InstagramOutlined />,
                    link: contactDetails?.instagramLink,
                  },
                  {
                    icon: <LinkedinOutlined />,
                    link: contactDetails?.linkedInLink,
                  },
                ].map((social, index) => (

                  <a
                    key={index}
                    href={social.link}
                    target="_blank"
                    rel="noreferrer"
                    className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-lg transition duration-300 hover:-translate-y-1 hover:bg-red-600"
                  >
                    {social.icon}
                  </a>

                ))}

              </div>

            </div>

          </div>

          {/* Bottom */}

          <div className="mt-20 flex flex-col items-center justify-between gap-6 border-t border-white/10 pt-8 text-sm text-slate-500 md:flex-row">

            <p>

              © {new Date().getFullYear()} {contactDetails?.siteName}. All
              rights reserved.

            </p>

            <div className="flex gap-8">

              <a href="#" className="hover:text-white">
                Privacy Policy
              </a>

              <a href="#" className="hover:text-white">
                Terms of Service
              </a>

              <a href="#" className="hover:text-white">
                Cookies
              </a>

            </div>

            <p>

              Designed by{" "}

              <span className="font-semibold text-red-400">

                SupaRecords Technologies

              </span>

            </p>

          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;